import React, {useState} from 'react'
import {Button, Form, Input, InputNumber, message, Modal, Radio, Table} from "antd";
import {ColumnsType} from "antd/es/table";
import {Link} from "react-router-dom";
import {useQuery} from "react-query";
import {REPO} from "../../Repository/repo";
import {queryKeys} from "../../Constant/QueryKeys";
import {VacationAnnualDetailRow} from "../../Model/VacationModel";

interface Props {
    employeeSeq: number
    employeeName: string
    baseYear: number
    onClose: () => void
}

const AnnualLeaveModal: React.FC<Props> = ({employeeSeq, employeeName, baseYear, onClose}) => {
    const [form] = Form.useForm()
    const [submitting, setSubmitting] = useState(false)

    const {data, refetch} = useQuery(
        [...queryKeys.vacationAnnualDetail, employeeSeq, baseYear],
        async () => {
            const res = await REPO.Vacation.GetAnnualDetail(employeeSeq, baseYear)
            return res.data
        }
    )

    const columns: ColumnsType<VacationAnnualDetailRow> = [
        {title: '등록일', dataIndex: 'registered_date', key: 'registered_date', render: (v) => v?.slice(0, 10)},
        {title: '구분', dataIndex: 'category', key: 'category'},
        {title: '휴가종류', dataIndex: 'vacation_type', key: 'vacation_type', render: (v) => v ?? '-'},
        {
            title: '기간',
            key: 'period',
            render: (_, r) => r.vacation_date_start === r.vacation_date_end
                ? r.vacation_date_start
                : `${r.vacation_date_start} ~ ${r.vacation_date_end}`,
        },
        {title: '사용일수', dataIndex: 'days', key: 'days'},
        {title: '상태', dataIndex: 'status', key: 'status'},
        {
            title: '휴가결재',
            key: 'doc',
            render: (_, r) => r.row_kind === 'document'
                ? <Link to={`/Vacation/Approval/${r.ref_seq}`}>{r.ref_seq}</Link>
                : '-',
        },
    ]

    const onApply = async (values: any) => {
        try {
            setSubmitting(true)
            await REPO.Vacation.PostLedger(employeeSeq, {
                sign: values.sign,
                days: Number(values.days),
                reason: values.reason,
                base_year: baseYear,
            })
            message.success("적용되었습니다.")
            form.resetFields()
            refetch()
        } catch (e: any) {
            message.error(e?.response?.data?.message || "적용에 실패했습니다.")
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <Modal
            open
            onCancel={onClose}
            footer={<Button onClick={onClose}>닫기</Button>}
            title={`연차사용내역 - ${employeeName}`}
            width={760}
        >
            {data && (
                <>
                    <div style={{marginBottom: 12}}>
                        <b>{data.base_year}년</b>
                        {" "}부여 <b>{data.summary.granted}</b>일
                        · 사용 <b>{data.summary.used}</b>일
                        · 잔여 <b style={{color: '#1677ff'}}>{data.summary.remaining}</b>일
                    </div>
                    <Table
                        size={"small"}
                        rowKey={(r) => `${r.row_kind}-${r.ref_seq}`}
                        dataSource={data.list}
                        columns={columns}
                        pagination={false}
                    />

                    {data.is_admin && (
                        <div style={{marginTop: 16, paddingTop: 12, borderTop: "1px solid #f0f0f0"}}>
                            <b>기본부여 / 수동 지급/차감</b>
                            <div style={{fontSize: 12, color: "#999", marginTop: 4}}>
                                * 기본부여(=): 해당 연도의 기본 부여일수 설정(덮어쓰기). 지급(+)/차감(-): 추가 가감 row 누적.
                            </div>
                            <Form
                                form={form}
                                layout={"inline"}
                                onFinish={onApply}
                                initialValues={{sign: "+", days: 1.0}}
                                style={{marginTop: 8}}
                            >
                                <Form.Item name={"sign"} rules={[{required: true}]}>
                                    <Radio.Group>
                                        <Radio value={"="}>기본부여(=)</Radio>
                                        <Radio value={"+"}>지급(+)</Radio>
                                        <Radio value={"-"}>차감(-)</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item name={"days"} rules={[{required: true}]}>
                                    <InputNumber min={0.125} step={0.25} addonAfter={"일"}/>
                                </Form.Item>
                                <Form.Item name={"reason"} rules={[{required: true, message: "사유 입력"}]} style={{flex: 1, minWidth: 240}}>
                                    <Input placeholder={"사유 (예: 리프레시 특별연차 부여 / 2026년 기본부여 15일)"}/>
                                </Form.Item>
                                <Button type={"primary"} htmlType={"submit"} loading={submitting}>적용</Button>
                            </Form>
                        </div>
                    )}
                </>
            )}
        </Modal>
    )
}

export default AnnualLeaveModal
